interface AccessLevels {
  PUBLIC: number
  PRIVATE: number
}

export const INTERNAL_ACCESS_LEVELS: AccessLevels = {
  PUBLIC: 0,
  PRIVATE: 1,
}
export default INTERNAL_ACCESS_LEVELS
